import dayjs, { Dayjs } from 'dayjs';
import {
  AlarmState,
  AlarmStateChange,
  Device,
  DeviceParameter,
  Measure
} from './@types/model/device';
import { CancelToken } from 'axios';
import axios from './utils/axios';
import { DeviceType } from './@types/model/user';

let cancel: any;

export type ChartDataPoint = { name: string; data: { x: number; y: number }[] };

export const getDeviceMeasures = (
  guid: string,
  start: Dayjs,
  end: Dayjs,
  okCallback: (device: Device, measures: Measure[], availableMetrics: string[]) => void
): void => {
  if (cancel) {
    cancel.cancel();
  }
  // @ts-ignore
  cancel = CancelToken.source();
  axios
    .get(`/api/v2/device/${guid}/measures`, {
      cancelToken: cancel.token,
      params: {
        start: start.unix(),
        end: end.unix()
      }
    })
    .then((data: any) => {
      const measures: Measure[] = [];
      const availableMetrics: string[] = [];
      data?.data?.included.forEach((item: any) => {
        if (item.type === 'App\\Domain\\Model\\Measure\\Measure') {
          const res = item as Measure;
          res.attributes.date = dayjs(res.attributes.date);
          res.attributes.data.forEach((item) => {
            if (!availableMetrics.includes(item?.name)) {
              availableMetrics.push(item?.name);
            }
          });
          measures.push(res);
        }
      });
      okCallback(data?.data?.data as Device, measures, availableMetrics);
    });
};

export const getDevice = (
  guid: string,
  start: Dayjs,
  end: Dayjs,
  okCallback: (
    device: Device,
    measures: Measure[],
    chartData: ChartDataPoint[],
    deviceType: DeviceType,
    availableMetrics: string[],
    alarmStateChanges: AlarmStateChange[],
    alarmState: AlarmState[]
  ) => void
): void => {
  if (cancel) {
    cancel.cancel();
  }
  // @ts-ignore
  cancel = CancelToken.source();
  axios
    .get(`/api/v2/device/${guid}/details`, {
      cancelToken: cancel.token,
      params: {
        start: start.unix(),
        end: end.unix()
      }
    })
    .then((result: any) => {
      if (result && typeof result.data !== 'undefined') {
        let data = result.data;
        const availableMetrics: string[] = [];
        const measures: Measure[] = [];
        const chartData: ChartDataPoint[] = [];
        const alarmStateChanges: AlarmStateChange[] = [];
        let alarmState: AlarmState[] = [];

        if (false && data.data.attributes.device_type_preset === 'preset:metrosil-v1') {
          let capacidad = 14000;
          data.data.attributes.parameters.forEach((param: DeviceParameter) => {
            if (param.identifier === 'capacidad') capacidad = parseInt(param.value);
          });

          let valor_raw_a: number = 0;
          let valor_peso_a: number = 0;
          let valor_raw_b: number = 0;
          let valor_peso_b: number = 0;
          data.data.attributes.parameters.forEach((parameter: DeviceParameter) => {
            switch (parameter.identifier) {
              case 'valor_raw_a':
                if (parameter.value) valor_raw_a = parseFloat(parameter.value);
                break;
              case 'valor_peso_a':
                if (parameter.value) valor_peso_a = parseFloat(parameter.value);
                break;
              case 'valor_raw_b':
                if (parameter.value) valor_raw_b = parseFloat(parameter.value);
                break;
              case 'valor_peso_b':
                if (parameter.value) valor_peso_b = parseFloat(parameter.value);
                break;
            }
          });

          // let weight_data: string | any[] = [];
          if (valor_raw_a !== 0 || valor_peso_a !== 0 || valor_raw_b !== 0 || valor_peso_b !== 0) {
            data.included = data.included
              .filter((item: any) => item.type === 'App\\Domain\\Model\\Measure\\Measure')
              .map((measure: Measure) => {
                let Percent = 0;
                let Remain = 0;
                let RawSensor = null;
                if (measure) {
                  measure.attributes?.data.forEach((attr) => {
                    switch (attr.name) {
                      case 'Remain':
                        Remain = attr.value;
                        break;
                      case 'Percent':
                        Percent = attr.value;
                        break;
                      case 'RawSensor':
                        RawSensor = attr.value;
                        break;
                    }
                  });
                }
                if (RawSensor === null) {
                  Percent = 0;
                  Remain = 0;
                } else {
                  Remain = Math.round(
                    (RawSensor - valor_raw_b) *
                      ((valor_peso_a - valor_peso_b) / (valor_raw_a - valor_raw_b)) +
                      valor_peso_b
                  );
                  Percent = Math.round(
                    (((RawSensor - valor_raw_b) *
                      ((valor_peso_a - valor_peso_b) / (valor_raw_a - valor_raw_b)) +
                      valor_peso_b) /
                      capacidad) *
                      100
                  );
                }
                if (measure.attributes && measure.attributes.data) {
                  measure.attributes.data = measure.attributes?.data
                    .map((attr) => {
                      let value = attr.value;
                      switch (attr.name) {
                        case 'Remain':
                          value = Remain;
                          break;
                        case 'Percent':
                          value = Percent;
                          break;
                      }
                      return {
                        ...attr,
                        value: value
                      };
                    })
                    .filter((attr) => {
                      if (attr.name === 'RawSensor') return false;
                      return true;
                    });
                }
                return measure;
              });
          }
        }

        // Calculate the median
        let listPresetsNotMedian = [
          'preset:trackgas-v1-device-type',
          'preset:fuelme:level-sensor',
          'preset:gespasa:diesel-plus-meter',
          'preset:submetrika:tedi-v1',
          'preset:trackgas-v1-sonda-presion-device-type'
        ];
        if (!listPresetsNotMedian.includes(data.data.attributes.device_type_preset)) {
          let capacidad: number = 0;
          // if (data.data.attributes.device_type_preset === 'preset:trackgas-flow-sensor-v1') {
          data.data.attributes.parameters.forEach((param: DeviceParameter) => {
            if (param.identifier === 'capacidad') {
              capacidad = parseFloat(param.value);
            }
          });
          // }
          const newMeasures = data.included.map((measure: any) => {
            if (measure.type === 'App\\Domain\\Model\\Measure\\Measure') {
              const attributes = measure.attributes.data.filter((attribute: any) => {
                if (attribute?.name === 'Remain') return true;
                return false;
              });
              let remain = 0;
              if (attributes.length > 0) {
                // Here, we have to modify the Remain Value
                remain = parseFloat(attributes[0].value);
                let sum = parseFloat(attributes[0].value);
                let total = 1;
                data.included.forEach((m: any) => {
                  if (m.type === 'App\\Domain\\Model\\Measure\\Measure') {
                    if (
                      Math.abs(dayjs(m.attributes?.date).diff(measure.attributes?.date, 'hour')) < 6
                    ) {
                      // We get the Remin value
                      const attrs = m.attributes?.data.filter((at: any) => {
                        if (at?.name === 'Remain' || at?.name === 'Weight') return true;
                        return false;
                      });
                      if (attrs.length > 0) {
                        // We have value! We sum this value
                        sum += parseFloat(attrs[0].value);
                        total += 1;
                      }
                    }
                  }
                });
                remain = sum / total;
              }

              // Modify Remain or Weight value for the new one
              let newData = measure.attributes.data
                .filter((d: any) => {
                  // We don't want to show Weight
                  if (d?.name === 'Weight') return false;
                  return true;
                })
                .map((d: any) => {
                  let value = d.value;
                  if (d?.name === 'Remain' || d?.name === 'Weight') {
                    value = remain;
                  }
                  // We transform WeigthC to Kilos
                  let name = d?.name;
                  if (d?.name === 'WeightC') {
                    name = 'Kilos';
                  }
                  if (d.type !== 'picture_data') {
                    return {
                      ...d,
                      name: name,
                      value: Math.round(parseFloat(value) * 100) / 100
                    };
                  } else {
                    return d;
                  }
                });

              // Queremos corregir un error que está ocurriendo con los porcentajes de las medidas. No cuadran con los valores de WeightC y la Capacidad del depósito.
              // Por tanto hacemos un refactor limitado a un tipo de device. Está relacionado con la tarea https://trello.com/c/sV8caQgS/237-front-ingafood-ver-que-pasa-que-aparecen-porcentajes-mayores-a-100
              let percentCorrected: number = -1;
              newData = newData.map((attr: any) => {
                if (
                  data.data.attributes.device_type_preset === 'preset:metrosil-v1' &&
                  capacidad !== 0
                ) {
                  if (attr?.name === 'Kilos') {
                    if (attr.value > capacidad) {
                      percentCorrected = 100;
                      attr.value = capacidad;
                    } else if (attr.value < 0) {
                      percentCorrected = 0;
                      attr.value = 0;
                    } else {
                      percentCorrected = Math.round((attr.value / capacidad) * 100 * 10) / 10;
                    }
                  }
                }
                return attr;
              });

              // We transform WeigthC to Kilos AND we don't want to show Weight
              // And the same if the device type is caudalimetro (preset:trackgas-flow-sensor-v1) we transform cumulative_flow to remain with formula remain = capacidad - cumulative_flow
              newData = newData.map((attr: any) => {
                if (data.data.attributes.device_type_preset === 'preset:trackgas-flow-sensor-v1') {
                  if (attr?.name === 'cumulative_flow') {
                    if (capacidad !== 0) {
                      let value_flowmeter = capacidad - parseFloat(attr.value);
                      if (value_flowmeter < 0) value_flowmeter = 0;
                      return {
                        ...attr,
                        value: value_flowmeter,
                        name: 'Remain'
                      };
                    } else {
                      return {
                        ...attr,
                        name: 'Remain'
                      };
                    }
                  }
                }
                if (attr?.name === 'WeightC') {
                  return {
                    ...attr,
                    name: 'Kilos'
                  };
                }
                if (attr?.name === 'WeightC') {
                  return {
                    ...attr,
                    name: 'Kilos'
                  };
                }
                if (attr?.name === 'Weight') {
                  return null;
                }
                if (percentCorrected !== -1 && attr?.name === 'Percent') {
                  return {
                    ...attr,
                    value: percentCorrected
                  };
                }
                return attr;
              });

              return {
                ...measure,
                attributes: {
                  ...measure.attributes,
                  data: newData
                }
              };
            }
            return measure;
          });
          data.included = newMeasures;

          if (data.data?.attributes?.device_type_preset === 'preset:trackgas-flow-sensor-v1') {
            let last_datas: any[] = [];
            if (
              data.data.attributes.last_data &&
              data.data.attributes.last_data.data &&
              data.data.attributes.last_data.data.length > 0
            ) {
              last_datas = data.data.attributes.last_data.data.map((d: any) => {
                if (d.name === 'cumulative_flow') {
                  let remain_flowmeter = capacidad - d.value;
                  if (remain_flowmeter < 0) remain_flowmeter = 0;
                  return {
                    ...d,
                    name: 'Remain',
                    value: remain_flowmeter
                  };
                }
                return d;
              });
            }
            data.data = {
              ...data.data,
              attributes: {
                ...data.data.attributes,
                last_data: {
                  ...data.data.attributes.last_data,
                  data: last_datas
                }
              }
            };
          }
        }

        data.included.forEach((item: any) => {
          if (item.type === 'App\\Domain\\Model\\Measure\\Measure') {
            const res = item as Measure;
            res.attributes.date = dayjs(res.attributes.date);
            res.attributes.data.forEach((item) => {
              if (!availableMetrics.includes(item?.name)) {
                availableMetrics.push(item?.name);
              }
              if (item.type === 'numeric_data') {
                const checkIndex = chartData.findIndex(
                  (cd: ChartDataPoint) => cd?.name === item?.name
                );
                if (checkIndex === -1) {
                  chartData.push({
                    name: item?.name,
                    data: [{ x: res.attributes.date.unix(), y: item.value }]
                  } as ChartDataPoint);
                } else {
                  chartData[checkIndex].data.push({ x: res.attributes.date.unix(), y: item.value });
                }
              }
            });
            measures.push(res);
          }
          if (item.type === 'App\\Domain\\Model\\AlarmStateChange\\AlarmStateChange') {
            alarmStateChanges.push({
              guid: item.guid,
              attributes: {
                ...item.attributes,
                created: dayjs(item.attributes.created)
              }
            } as AlarmStateChange);
          }
          if (item.type === 'App\\Domain\\Model\\AlarmState\\AlarmState') {
            alarmState.push({
              guid: item.guid,
              attributes: {
                ...item.attributes,
                last_update: dayjs(item.attributes.last_update)
              }
            } as AlarmState);
          }
        });

        okCallback(
          data.data as Device,
          measures,
          chartData,
          {} as DeviceType,
          availableMetrics,
          alarmStateChanges,
          alarmState
        );
      }
    });
};

export const putMeasure = (measure: Measure, okCallback: () => void, koCallback: () => void) => {
  axios
    .put(`/api/v2/measure/${measure.guid}`, { data: measure.attributes.data })
    .then(okCallback)
    .catch(koCallback);
};
export const postMeasure = (measure: Measure, device: Device) => {
  return axios.post(`/api/v2/measure`, {
    data: measure.attributes.data,
    workspace: device.attributes.workspace,
    device_guid: device.guid,
    date: measure.attributes.date.unix()
  });
};
